import { Platform } from 'react-native';
export { default as createStackNavigator } from './navigators/createStackNavigator';
export var Assets = Platform.select({
  ios: [require('./views/assets/back-icon.png'), require('./views/assets/back-icon-mask.png')],
  default: [require('./views/assets/back-icon.png')]
});
export { default as Header } from './views/Header/Header';
export { default as HeaderBackButton } from './views/Header/HeaderBackButton';
export { default as HeaderTitle } from './views/Header/HeaderTitle';
export { default as HeaderStyleInterpolator } from './views/Header/HeaderStyleInterpolator';
export { default as StackView } from './views/StackView/StackView';
export { default as StackViewCard } from './views/StackView/StackViewCard';
export { default as StackViewLayout } from './views/StackView/StackViewLayout';
export { default as StackViewStyleInterpolator } from './views/StackView/StackViewStyleInterpolator';
export { default as StackViewTransitionConfigs } from './views/StackView/StackViewTransitionConfigs';
export { default as createPointerEventsContainer } from './views/StackView/createPointerEventsContainer';
export { default as Transitioner } from './views/Transitioner';
export { default as ScenesReducer } from './views/ScenesReducer';
export { default as StackGestureContext } from './utils/StackGestureContext';